var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('template-administrator',[_c('div',{attrs:{"slot":"container"},slot:"container"},[_c('create-dispatch-location'),_c('br'),_c('table-dispatch-location')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }